export default __webpack_public_path__ + "static/anouar-ce4317497c725bf9fc5f87e14d1fcc45.jpg";